export const STUDENT_INTERACTION_STATE = 'STUDENT_INTERACTION_STATE';
export const CLEAR_STUDENT_INTERACTION_STATE = 'CLEAR_STUDENT_INTERACTION_STATE';
export const STUDENT_MODAL_STATE = 'STUDENT_MODAL_STATE';
export const CLEAR_MODAL_STATE = 'CLEAR_MODAL_STATE';

export const studentInteraction = data => ({ type: STUDENT_INTERACTION_STATE, data });
export const clearStudentInteraction = () => ({ type: CLEAR_STUDENT_INTERACTION_STATE });
export const studentInteractionModal = data => ({ type: STUDENT_MODAL_STATE, data });
export const clearStudentInteractionModal = () => ({ type: CLEAR_MODAL_STATE });
